module.exports = __webpack_public_path__ + "static/media/systemConfig.1495263b.svg";